module.exports = __webpack_public_path__ + "img/u142.bc8f35f4.jpg";